import styled, { css } from 'styled-components';

const StyledFilterResults = styled.div`
  @keyframes slideIn {
    0% {
      opacity: 0;
      transform: translateY(50px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  ${props =>
    props.isVisible &&
    css`
      display: inline;
      animation: slideIn 0.4s ease-in-out forwards;
    `}
`;

export default StyledFilterResults;
